/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People2Icon16Solid = forwardRef('People2Icon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8.495 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" }),
        React.createElement("path", { d: "M12 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" }),
        React.createElement("path", { d: "M14.007 13H10.91c.055-.156.085-.325.085-.5v-.493c0-.895-.262-1.68-.76-2.313a3.547 3.547 0 0 0-.396-.425C10.376 9.073 10.962 9 11.5 9c1.549 0 3.5.604 3.5 3.007a.993.993 0 0 1-.993.993Z" }),
        React.createElement("path", { d: "M9.995 12.007C9.995 9.604 7.487 9 5.495 9c-1.991 0-4.5.604-4.5 3.007 0 .548.445.993.994.993h7.013a.993.993 0 0 0 .993-.993Z" })));
});
